import React, { useContext } from 'react'
import { DownloadCSVButton } from '../../../../components/common/download-csv-button/DownloadCSVButton'

import { SurveyResultsDownloadCsvDocument } from './SurveyResultsDownloadCSV.codegen'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { prepareSurveyResultsExportData } from './csv-surveys'
import { useDateFilterContext } from '../../../../components/common/dateFilter'

export interface ISurveyResultsFilter {
  from: Date
  to: Date
  dateRange?: number
}

const SurveyResultsDownloadCSV = () => {
  const { survey } = useContext(ManageSurveyContext)
  const [filters] = useDateFilterContext()

  return (
    <DownloadCSVButton
      fileName={`looop-survey-${survey.id}`}
      dataPath={'data.admin.survey'}
      queryOptions={() => ({
        variables: {
          id: survey.id,
          filters: [
            { name: 'from', value: filters.from.toISOString() },
            { name: 'to', value: filters.to.toISOString() }
          ]
        },
        query: SurveyResultsDownloadCsvDocument,
        fetchPolicy: 'no-cache'
      })}
      prepareData={prepareSurveyResultsExportData}
    />
  )
}

export default SurveyResultsDownloadCSV
